import { styled, theme } from "../../theme";

const renderIcon = (type: string) => {
  if (type === "pdf") {
    return theme.icons.resourcePdfFile;
  }
  if (type === "hyperlink") {
    return theme.icons.resourceHyperLink;
  } else {
    return theme.icons.resourceDefaultIcon;
  }
};

export const ResourceItemContainer = styled.a`
  box-sizing: border-box;
  min-width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items:center;
  min-height: 100%;
  height: 100%;
  color: ${(props) => props.color || props.theme.color.text};
  text-decoration: none;
`;

export const ResourceIconContainer = styled.div`
  width: 10%;
  min-height: 100%;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    width: 13%;
    justify-content: flex-start;
  }
`;

export const ResourceIcon = styled.div<{ resourceType: string }>`
  width: 2.5em;
  height: 2.5em;
  background-image: ${({ resourceType }) => `url(${renderIcon(resourceType)})`};
  background-size: 90%;
  background-repeat: no-repeat;
  background-position: center;
  background-color: ${(props) => props.theme.color.secondary};
  display: block;
  border-radius: 2em;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    width: 1.5em;
    height: 1.5em;
  }
`;
export const ResourceInfoContainer = styled.div`
  box-sizing: border-box;
  width: 93%;
  min-height: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    justify-content: flex-start;
  }
`;

export const ResourceName = styled.div`
  box-sizing: border-box;
  text-transform: uppercase;
  font-weight: bold;
  color: #fff;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    font-size: 0.9em;
    padding-top: 0.2em;
  }
`;

export const ResourceDescription = styled.div`
  box-sizing: border-box;
`;
